import React from "react";
import "./Rejected.css";
import { CloseCircleFilled } from '@ant-design/icons';

export const Rejected = props => {
  return (
    <div className="rejectedRoot">
      <div className="rejectedWrapper">
        <div className="rejectedImg">
          <CloseCircleFilled className="rejectedIcon" />
        </div>
        <p>{props.message}</p>
      </div>
    </div>
  );
}
